import { Observable, Subscription, of } from 'rxjs';
import { BreakpointService } from '../services/breakpoint.service';

export const ResponsiveState = (_class: any) =>
	class extends _class {
		constructor(public breakpointService: BreakpointService) {
			super();
		}

		isXSmall = false;
		isSmall = false;
		isMedium = false;
		isWebLandscape = false;
		subscription: Subscription = new Subscription();

		stepperOrientation: Observable<string>;

		setResponsiveState() {
			const xSmallSub = this.breakpointService.isXSmall$.subscribe(
				(isXSmall: boolean) => {
					this.isXSmall = isXSmall;
				}
			);

			const smallSub = this.breakpointService.isSmall$.subscribe(
				(isSmall: boolean) => {
					this.isSmall = isSmall;
				}
			);

			const mediumSub = this.breakpointService.isMedium$.subscribe(
				(isMedium: boolean) => {
					this.isMedium = isMedium;
				}
			);

			const webLandscapeSub = this.breakpointService.isWebLandscape$.subscribe(
				(isWebLandscape: boolean) => {
					this.isWebLandscape = isWebLandscape;
					this.stepperOrientation = of(
						isWebLandscape ? 'horizontal' : 'vertical'
					);
				}
			);

			this.subscription.add(xSmallSub);
			this.subscription.add(smallSub);
			this.subscription.add(mediumSub);
			this.subscription.add(webLandscapeSub);
		}
	};

export class BaseResponsiveState extends ResponsiveState(class {}) {}
